/**
* PulseBetProgressPeriodData defines the data for the periods in progress bar animation
*
* @typedef PulseBetProgressPeriodData
* @type {type}
* @property {startTime} startTime The game time the period starts
* @property {duration} duration Duration of the period
*/

export class PulseBetProgressPeriodData {
    startTime: string;
    duration: number;
    id: string;
    periodNumber:number;

    constructor(source: PulseBetProgressPeriodData) {
        this.startTime = source.startTime;
        this.duration = source.duration;
        this.id = source.id;
        this.periodNumber = source.periodNumber;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./data/models/PulseBetProgressPeriodData/PulseBetProgressPeriodData.ts